import './Modal.css';

import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

// import { MODAL_STYLE_RESET } from 'utils/constants';

import Button from '../Button';
import Icon from '../Icon';

ReactModal.setAppElement('#root');

let modalResets = {
    overlay: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        backgroundColor: null
    },
    content: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        border: null,
        background: null,
        overflow: null,
        WebkitOverflowScrolling: null,
        borderRadius: null,
        outline: null,
        padding: null
    }
}

const Modal = ({children, className, confirmButtonOnClick, confirmButtonText, contentLabel, declineButtonOnClick, declineButtonText, show, showActivityIndicator, title}) => (
    <ReactModal className={className}
                closeTimeoutMS={200}
                contentLabel={contentLabel || 'Modal'}
                style={modalResets}
                isOpen={show === true}>
        {title != null ? (
            <h6 className="c-modal__title">
                {title}

                {confirmButtonOnClick || declineButtonOnClick ? (
                    <Button className="c-modal__close-button"
                            noStyles
                            onClick={() => declineButtonOnClick ? declineButtonOnClick() : confirmButtonOnClick()}>
                        <Icon type="x" />
                    </Button>
                ) : null}
            </h6>
        ) : null}

        <div className="c-modal__content">
            {children}

            {confirmButtonText || declineButtonText ? (
                <div className="c-modal__button-wrapper">
                    {confirmButtonText && confirmButtonOnClick ? (
                        <Button className="c-modal__confirm-button"
                                onClick={confirmButtonOnClick}
                                showActivityIndicator={showActivityIndicator}>
                            {confirmButtonText}
                        </Button>
                    ) : null}

                    {declineButtonText && declineButtonOnClick ? (
                        <Button className="c-modal__decline-button"
                                onClick={declineButtonOnClick}
                                noStyles>
                            {declineButtonText}
                        </Button>
                    ) : null}
                </div>
            ) : null}
        </div>
    </ReactModal>
);

Modal.propTypes = {
    className: PropTypes.string,
    confirmButtonOnClick: PropTypes.func,
    confirmButtonText: PropTypes.string,
    contentLabel: PropTypes.string,
    declineButtonOnClick: PropTypes.func,
    declineButtonText: PropTypes.string,
    show: PropTypes.bool.isRequired,
    showActivityIndicator: PropTypes.bool,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
};

export default Modal;



// WEBPACK FOOTER //
// ./src/_components/FormComponents/Modal/index.js